import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// TODO: Replace with your Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyAhTGwen0WisdW1mK3YH47olgzfwhpKQsU",
  authDomain: "liasoning-iq.firebaseapp.com",
  projectId: "liasoning-iq",
  storageBucket: "liasoning-iq.firebasestorage.app",
  messagingSenderId: "669094382700",
  appId: "1:669094382700:web:ea4607b09fd9e219251c49",
  measurementId: "G-77T35VKRM5"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Configure Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;
